import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import CityListLayer from "../components/CityListLayer";
import CityModal from "../components/CityModal";

const CityPage = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);

  const fetchCities = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/city`);
      const data = await res.json();
      setCities(Array.isArray(data) ? data : []);
    } catch (err) {
      console.log("Error:", err);
      setCities([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCities();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Cities" />

      {loading ? (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      ) : (
        <CityListLayer
          data={cities}
          onAdd={() => setModalData({})}
          onEdit={(row) => setModalData(row)}
          onRefresh={fetchCities}
        />
      )}

      <CityModal
        show={modalData !== null}
        onClose={() => setModalData(null)}
        data={modalData}
        onSaved={fetchCities}
      />
    </MasterLayout>
  );
};

export default CityPage;
